import { useMutation } from "@tanstack/react-query";
import React from "react";
import useGoogleMapsAddress from "../hooks/useGoogleMapsAddress";
import { Geo } from "../messages";
import { SEARCH_SVG, TIMES_SVG } from "../utils/svgs";
import { AppIcon } from "./Generic/AppIcon";
import "./AvailableVisitLiveMapAddressSearchBar.css";
import { translate } from "../translate";
import { STRINGS } from "../strings";
import { useMap } from "react-map-gl/maplibre";

const MapSearchAddressBar = () => {
  const {
    handleChange: handleChange,
    placePredictions,
    input,
    setInput,
    getDetails,
    showPredictions,
    setShowPredictions,
  } = useGoogleMapsAddress();
  const map = useMap();

  const centerMap = (place: Geo) => {
    map.current?.flyTo({ zoom: 16, animate: true, duration: 1000, center: place });
  };

  const getDetailsMutation = useMutation(getDetails, {
    onMutate: () => {
      setShowPredictions(false);
    },
    onSuccess: (data) => {
      if (data !== null && data.geometry !== undefined) {
        setInput("");
        centerMap({
          lat: data.geometry.location.lat(),
          lng: data.geometry.location.lng(),
        });
      }
    },
  });

  const handleClickPrediction = (prediction: google.maps.places.AutocompletePrediction) => {
    getDetailsMutation.mutate(prediction);
  };

  const handleInputValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange(event.currentTarget.value);

    if (event.target.value === "") {
      setShowPredictions(false);
    }
  };

  const handleClearSerachText = () => {
    setInput("");
    setShowPredictions(false);
  };

  return (
    <>
      <div className="AvailableVisitsLiveMap__searchAddressBar">
        <AppIcon className="AvailableVisitsLiveMap__searchAddressBarIcon" icon={SEARCH_SVG} />
        <input
          className="AvailableVisitsLiveMap__searchAddressBarInput"
          placeholder={translate(STRINGS.VISITS_MAP_SEARCH_ADDRESS_PLACEHOLDER)}
          disabled={getDetailsMutation.isLoading}
          value={input}
          onChange={handleInputValueChange}
        />
        {input === "" ? null : (
          <AppIcon
            className="AvailableVisitsLiveMap__closeSearchAddressIcon"
            icon={TIMES_SVG}
            onClick={handleClearSerachText}
          />
        )}
      </div>

      {!getDetailsMutation.isLoading && showPredictions ? (
        <div
          className="AvailableVisitsLiveMap__searchAddressPredictionsContainer"
          onWheel={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
          onTouchMove={(e) => e.stopPropagation()}
        >
          {placePredictions.map((prediction) => (
            <div
              className="AvailableVisitsLiveMap__searchAddressPrediction"
              key={`prediction-${prediction.place_id}`}
              onClick={() => handleClickPrediction(prediction)}
            >
              {prediction.description}
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default MapSearchAddressBar;
